import { FormControlLabel, Stack, Typography } from '@mui/material';
import { useField } from 'formik';
import InputWrapper from '../InputWrapper';
import Switch from '../../../global/IOSSwitch';

interface MultiSwitchProps {
  name: string;
  label: string;
  description?: string;
  isLabelMultiline?: boolean;
  disabled?: boolean;
  options: {
    title?: string;
    value: string | boolean | number;
    label: string;
    category?: string;
  }[];
  tooltip?: string;
  required?: boolean;
  gap?: number;
}

function MultiSwitchInput({
  name,
  label,
  description,
  isLabelMultiline,
  disabled,
  options,
  tooltip,
  required,
  gap = 1.5,
}: MultiSwitchProps) {
  const [{ value }, , { setValue, setTouched }] = useField(name.toString());
  const selectedList = (value ?? []) as (string | number | boolean)[];

  return (
    <InputWrapper
      label={label}
      description={description}
      isLabelMultiline={isLabelMultiline}
      name={name}
      tooltip={tooltip}
      required={required}>
      <Stack width="100%" gap={gap} mt={2}>
        {options.map(option => (
          <FormControlLabel
            key={String(option.value)}
            sx={{
              width: '100%',
              p: 0,
              ml: 0,
              mr: 0,
              justifyContent: 'space-between',
              gap: 2,
            }}
            labelPlacement="start"
            control={
              <Switch
                checked={selectedList.includes(option.value)}
                onChange={() => {
                  setValue(
                    selectedList.includes(option.value)
                      ? selectedList.filter(val => val !== option.value)
                      : [...selectedList, option.value],
                  );
                  setTimeout(() => setTouched(true), 0);
                }}
                disabled={disabled}
                sx={{
                  p: 0,
                  mr: 1,
                }}
              />
            }
            label={
              <Stack>
                {!!option.title && (
                  <Typography variant="h5">{option.title}</Typography>
                )}
                <Typography variant="body2" whiteSpace="pre-line">
                  {option.label}
                </Typography>
              </Stack>
            }
            disabled={disabled}
          />
        ))}
      </Stack>
    </InputWrapper>
  );
}

export default MultiSwitchInput;
